import { FC, useState } from 'react';
import { Divider, MultiSelect, SectionToggle, Switch } from '@features/ui';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ProductFormData } from '@src/types';
import { mailchimpListSegments } from '@features/admin/productsAddons/productsAddonsData.ts';

export const ProductOptionsForm: FC<UseFormReturn<ProductFormData>> = ({
  control,
}) => {
  const [hide, setHide] = useState(false);

  return (
    <div className={'text-xs mb-[47px]'}>
      <Divider />
      <SectionToggle
        className={'mt-5'}
        label={'Product Options'}
        toggle={hide}
        onChange={setHide}
      />
      {!hide && (
        <div className={'flex flex-col lg:gap-y-0 gap-y-7 mt-[21px]'}>
          <div className={'flex xl:w-[80%] w-full gap-20'}>
            <div className={'lg:flex hidden flex-2'} />
            <Controller
              control={control}
              name="disable_product_link"
              render={({ field }) => (
                <div
                  className={
                    'flex flex-1 lg:flex-row flex-col xl:w-[80%] w-full'
                  }
                >
                  <Switch
                    checked={!!field.value}
                    label={'Disable Product Link'}
                    onCheckedChange={(value) => field.onChange(value)}
                  />
                </div>
              )}
            />
          </div>
          <div className={'flex lg:flex-row flex-col xl:w-[80%] w-full'}>
            <Controller
              control={control}
              name="mailchimp_list_segments"
              render={({ field }) => (
                <div className={'flex flex-2 flex-col gap-1'}>
                  <p className={'ml-2 mb-1'}>Mailchimp List Segments</p>
                  <MultiSelect
                    options={mailchimpListSegments}
                    placeholder={'Please select'}
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                  <p>
                    {`Tags users when user makes purchase of this product user will be tagged only if account is suppose to be added to list according to aMemver CP → Protect Content → Newsletters configuration`}
                  </p>
                </div>
              )}
            />
            <div className={'flex-1'} />
          </div>
        </div>
      )}
    </div>
  );
};
